import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@/core/services/open-api/user.service';
import { Account } from '@/core/models/account';

@Component({
    selector: 'app-addons',
    templateUrl: './addons.component.html',
    styleUrls: ['./addons.component.scss'],
    standalone: false,
})
export class AddonsComponent implements OnInit {
    public addBuzzerQuantity = 1;
    displayFrontPage = true;

    constructor(
        private readonly translate: TranslateService,
        public userService: UserService,
    ) {}

    ngOnInit(): void {
        this.userService.loadAccount().subscribe((account: Account) => {
            this.addBuzzerQuantity = account.getActiveUserCount();
        });
    }

    public goToBuyBuzzer(): void {
        this.translate
            .get(['language_parameter_store_link', 'addons_hardware_woocommerce_product_id'])
            .subscribe((translations) => {
                this.userService.getLicensesURL().subscribe((data) => {
                    const domain = data.split('?');
                    const newUrl =
                        domain[0] +
                        translations.language_parameter_store_link +
                        '/cart' +
                        '?' +
                        'add-to-cart=' +
                        translations.addons_hardware_woocommerce_product_id +
                        '&quantity=' +
                        this.addBuzzerQuantity +
                        '&' +
                        domain[1];
                    // console.debug("newUrl: " + newUrl)
                    window.open(newUrl, '_self');
                });
            });
    }

    toggleFrontDisplay(): void {
        this.displayFrontPage = !this.displayFrontPage;
    }
}
